import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponentComponent } from './pages/main-component/main-component.component';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaplistComponent } from './pages/maplist/maplist.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AddmapdataComponent } from './pages/maplist/addmapdata/addmapdata.component';
import { EditmapdataComponent } from './pages/maplist/editmapdata/editmapdata.component';
import { ActiveGamesComponent } from './pages/active-games/active-games.component';
import { CharacterPortfolioComponent } from './pages/character-portfolio/character-portfolio.component';
import { ContentCreatorComponent } from './pages/content-creator/content-creator.component';
import { SocialFeedComponent } from './pages/social-feed/social-feed.component';
import { SocialEmojiPickerComponent } from './pages/social-feed/components/social-emoji-picker/social-emoji-picker.component';
import { SocialPostMenuComponent } from './pages/social-feed/components/social-post-menu/social-post-menu.component';
import { SocialConfirmDialogComponent } from './pages/social-feed/components/social-confirm-dialog/social-confirm-dialog.component';
import { SocialReportDialogComponent } from './pages/social-feed/components/social-report-dialog/social-report-dialog.component';
import { SocialSearchComponent } from './pages/social-feed/components/social-search/social-search.component';
import { SocialImageGalleryComponent } from './pages/social-feed/components/social-image-gallery/social-image-gallery.component';
import { SocialAttachmentPreviewComponent } from './pages/social-feed/components/social-attachment-preview/social-attachment-preview.component';
import { SocialPollComponent } from './pages/social-feed/components/social-poll/social-poll.component';
import { SocialPollComposerComponent } from './pages/social-feed/components/social-poll-composer/social-poll-composer.component';
import { SocialShellComponent } from './pages/social-feed/components/social-shell/social-shell.component';
import { SocialPostCardComponent } from './pages/social-feed/components/social-post-card/social-post-card.component';
import { SocialComposerComponent } from './pages/social-feed/components/social-composer/social-composer.component';
import { SocialNotificationsComponent } from './pages/social-notifications/social-notifications.component';
import { SocialCommentsComponent } from './pages/social-feed/components/social-comments/social-comments.component';
import { SocialPostComponent } from './pages/social-post/social-post.component';
import { SocialMessagesComponent } from './pages/social-messages/social-messages.component';
import { SocialGroupComponent } from './pages/social-group/social-group.component';
import { CommunitiesComponent } from './pages/communities/communities.component';
import { CommunityComponent } from './pages/community/community.component';
import { CommunityFormComponent } from './pages/community-form/community-form.component';
import { CommunityJoinComponent } from './pages/community-join/community-join.component';
import { SocialGameGroupComponent } from './pages/social-game-group/social-game-group.component';
import { SocialProfileComponent } from './pages/social-profile/social-profile.component';
import { ContentCreatorDetailComponent } from './pages/content-creator/content-creator-detail/content-creator-detail.component';
import { GameMasterDetailComponent } from './pages/game-master-detail/game-master-detail.component';
import { GmplayComponent } from './pages/gmplay/gmplay.component';
import { HomeComponent } from './pages/home/home.component';
import { StoreRailComponent } from './pages/home/store-rail/store-rail.component';
import { RailLabComponent } from './pages/home/rail-lab/rail-lab.component';
import { ThemeLabComponent } from './pages/theme-lab/theme-lab.component';
import { StoreStubComponent } from './pages/store/store-stub.component';
import { PlayerComponent } from './pages/player/player.component';
import { PlayerDetailComponent } from './pages/player/player-detail/player-detail.component';
import { RouterModule } from '@angular/router';
import { CookiespageComponent } from './pages/cookiespage/cookiespage.component';
import { MapInviteModalComponent } from './pages/map-invite-modal/map-invite-modal.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { CreategameComponent } from './pages/active-games/creategame/creategame.component';
import { InvitationpageComponent } from './pages/invitationpage/invitationpage.component';
import { InvitationDetailpageComponent } from './pages/invitationpage/invitation-detailpage/legacy-invitation-page/invitation-detailpage.component';
// HeaderComponent, LeftsidebarComponent, FooterComponent now declared in SharedModule
// (see shared-module/shared/shared.module.ts) so non-app.module feature modules can use them too.
import { EditgamemasterdetailComponent } from './pages/game-master-detail/editgamemasterdetail/editgamemasterdetail.component';
import { CityEnterDeletemodelComponent } from './modal/deletemodel/deletemodel.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { CommonuploadimagemodelComponent } from './pages/shared/commonuploadimagemodel/commonuploadimagemodel.component';
import { PlayersCharacterListComponent } from './pages/active-games/players-character-list/players-character-list.component';
import { MapviewComponent } from './pages/mapview/mapview.component';
import { MapPlayerViewComponent } from './pages/character-portfolio/map-player-view/map-player-view.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { PlayerStoryComponent } from './modal/player-story/player-story.component';
import { CategoryPlayerViewModalComponent } from './modal/category-player-view-modal/category-player-view-modal.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AddContentComponent } from './pages/content-creator/add-content/add-content.component';
import { ContentCreatorModalDetailComponent } from './pages/content-creator/content-creator-modal-detail/content-creator-modal-detail.component';
import { InvitationAcceptRejectModalComponent } from './pages/invitationpage/invitation-detailpage/invitation-model/invitation-model.component';
import { UploadpartytokenComponent } from './pages/active-games/uploadpartytoken/uploadpartytoken.component';
import { AuthPagesModule } from './pages/auth/auth-pages.module';
import { WorldBuilderModule } from './features/world-builder/world-builder.module';

import { environment } from '../environments/environment';
import { GameDetailsModalComponent } from './pages/active-games/game-details-modal/game-details-modal.component';
import { InvitationModalComponent } from './pages/active-games/invitation-modal/invitation-modal.component';
import { DeleteGameAndCharacterModalComponent } from './pages/game-master-detail/delete-character-modal/delete-character-modal.component';
import { RetirecharacterComponent } from './pages/player/modals/retirecharacter/retirecharacter.component';
import { AiGenerationComponent } from './pages/player/modals/ai-generation/ai-generation.component';
import { AIPotraitPromptComponent } from './pages/player/modals/ai-generation/prompt-modal/ai-potrait-prompt/ai-potrait-prompt.component';
import { CreateGameMapSelectionModalComponent } from './pages/active-games/creategame/create-game-map-selection-modal/create-game-map-selection-modal.component';
import { CreateGameMapViewComponent } from './pages/active-games/create-game-map-view/create-game-map-view.component';
import { CreateGameInfoModalComponent } from './pages/active-games/create-game-info-modal/create-game-info-modal.component';
import { CreateGameInvitationModalComponent } from './pages/active-games/create-game-invitation-modal/create-game-invitation-modal.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { CommonCharacterImageUploadModalComponent } from './pages/shared/common-character-image-upload-modal/common-character-image-upload-modal.component';
import { ContentImageUploadModalComponent } from './pages/shared/content-image-upload-modal/content-image-upload-modal.component';
import { UnsavedModalComponent } from './pages/player/player-detail/unsaved-modal/unsaved-modal.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { PreviewInterceptor } from './preview/preview.interceptor';
import { CityMapViewComponent } from './pages/city-map-view/city-map-view.component';
import { LearnMoreComponent } from './pages/learn-more/learn-more.component';
import { SharedModule } from './pages/shared-module/shared/shared.module';
import { SubscriptionComponent } from './pages/subscription/subscription-component/subscription.component';
import { FAQComponent } from './pages/faq/faq.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { ConfirmModalComponent } from './modal/confirm-modal/confirm-modal.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MapDeleteComponent } from './pages/maplist/map-delete/map-delete.component';
import { RefreshPlanDetailsInterceptor } from './interceptors/refresh-plan-details.interceptor';
import { InviteConfirmationModalComponent } from './pages/invitationpage/invitation-detailpage/confirmation-modal/invite-confirmation-modal.component';
import { GetNotificationCountInterceptor } from './interceptors/get-notification-count.interceptor';
import { CreateNoteComponent } from './modal/private-note/create-note.component';
import { NoteListComponent } from './modal/note-list/note-list.component';
import { ReportingModalComponent } from './modal/reporting-modal/reporting-modal.component';
import { TokenPlacementModalComponent } from './modal/token-placement-modal/token-placement-modal.component';
import { MapModifyComponent } from './pages/maplist/map-modify/map-modify.component';
import { MapPacksComponent } from './pages/map-packs/map-packs.component';
import { MapImageChangeComponent } from './pages/maplist/map-image-change/map-image-change.component';
import { AzgaarMapGeneratorInfoComponent } from './pages/maplist/azgaar-map-generator-info/azgaar-map-generator-info.component';
import { SubscriptionPlanDetailsComponent } from './pages/subscription/modals/subscription-plan-details/subscription-plan-details.component';
import { AiFailureComponent } from './pages/player/modals/ai-failure/ai-failure.component';
import { AiTokenRestockComponent } from './pages/player/modals/ai-token-restock/ai-token-restock.component';
import { TokenCreditModalComponent } from './pages/shared/token-credit-modal/token-credit-modal.component';
import { WorldCreditsModalPurchaseComponent } from './pages/player/modals/ai-generation/world-credits-modal-purchase/world-credits-modal.component';
import { TokenSuccessComponent } from './pages/shared/token-success-modal/token-success-modal.component';
import { PlaceContentModalComponent } from './modal/place-content-modal/place-content-modal.component';
import { LoaderComponent } from './pages/shared/loader/loader.component';
import { IntroSplashComponent } from './pages/shared/intro-splash/intro-splash.component';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { ContentDeleteModalComponent } from './modal/content-delete-modal/content-delete-modal.component';
import { SavingLoaderModalComponent } from './modal/saving-loader-modal/saving-loader-modal.component';
import { MarketplaceAuthInterceptor } from './interceptors/marketplace-auth.interceptor';
import { provideNgxStripe, StripeElementsDirective, StripePaymentElementComponent } from 'ngx-stripe';
import { CartComponent } from './pages/marketplace/cart/cart.component';
import { CheckoutComponent } from './pages/marketplace/checkout/checkout.component';
import { CheckoutSuccessComponent } from './pages/marketplace/checkout-success/checkout-success.component';
import { VendorOnboardingComponent } from './pages/marketplace/vendor-onboarding/vendor-onboarding.component';
import { VendorDashboardComponent } from './pages/marketplace/vendor-dashboard/vendor-dashboard.component';
import { AllShopsComponent } from './pages/marketplace/all-shops/all-shops.component';
import { FavoritesComponent } from './pages/marketplace/favorites/favorites.component';
import { ListingFormComponent } from './pages/marketplace/listing-form/listing-form.component';
import { ListingDetailComponent } from './pages/marketplace/listing-detail/listing-detail.component';
import { OrdersComponent } from './pages/marketplace/orders/orders.component';
import { BulkUploadComponent } from './pages/marketplace/bulk-upload/bulk-upload.component';
import { AdminOverviewComponent } from './pages/admin/admin-overview/admin-overview.component';
import { AdminUsersComponent } from './pages/admin/admin-users/admin-users.component';
import { AdminUserDetailComponent } from './pages/admin/admin-user-detail/admin-user-detail.component';
import { AdminReportsComponent } from './pages/admin/admin-reports/admin-reports.component';

@NgModule({
  declarations: [
    AppComponent,
    MainComponentComponent,
    MaplistComponent,
    AddmapdataComponent,
    EditmapdataComponent,
    ActiveGamesComponent,
    CharacterPortfolioComponent,
    ContentCreatorComponent,
    SocialFeedComponent,
    SocialEmojiPickerComponent,
    SocialPostMenuComponent,
    SocialConfirmDialogComponent,
    SocialReportDialogComponent,
    SocialSearchComponent,
    SocialImageGalleryComponent,
    SocialAttachmentPreviewComponent,
    SocialPollComponent,
    SocialPollComposerComponent,
    SocialCommentsComponent,
    SocialPostComponent,
    SocialMessagesComponent,
    SocialGroupComponent,
    SocialShellComponent,
    SocialPostCardComponent,
    SocialComposerComponent,
    SocialNotificationsComponent,
    CommunitiesComponent,
    CommunityComponent,
    CommunityFormComponent,
    CommunityJoinComponent,
    SocialGameGroupComponent,
    SocialProfileComponent,
    ContentCreatorDetailComponent,
    GameMasterDetailComponent,
    GmplayComponent,
    HomeComponent,
    StoreRailComponent,
    RailLabComponent,
    ThemeLabComponent,
    StoreStubComponent,
    PlayerComponent,
    PlayerDetailComponent,
    CookiespageComponent,
    MapInviteModalComponent,
    CreategameComponent,
    InvitationpageComponent,
    InvitationDetailpageComponent,
    MapviewComponent,
    EditgamemasterdetailComponent,
    CityEnterDeletemodelComponent,
    CommonuploadimagemodelComponent,
    PlayersCharacterListComponent,
    MapPlayerViewComponent,
    UserProfileComponent,
    PlayerStoryComponent,
    CategoryPlayerViewModalComponent,
    AddContentComponent,
    InvitationAcceptRejectModalComponent,
    UploadpartytokenComponent,
    GameDetailsModalComponent,
    InvitationModalComponent,
    DeleteGameAndCharacterModalComponent,
    SubscriptionComponent,
    RetirecharacterComponent,
    AiGenerationComponent,
    AIPotraitPromptComponent,
    CreateGameMapSelectionModalComponent,
    CreateGameMapViewComponent,
    CreateGameInfoModalComponent,
    CreateGameInvitationModalComponent,
    ErrorPageComponent,
    CommonCharacterImageUploadModalComponent,
    ContentImageUploadModalComponent,
    CityMapViewComponent,
    UnsavedModalComponent,
    LearnMoreComponent,
    FAQComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    ConfirmModalComponent,
    MapDeleteComponent,
    InviteConfirmationModalComponent,
    ContentCreatorModalDetailComponent,
    CreateNoteComponent,
    NoteListComponent,
    ReportingModalComponent,
    TokenPlacementModalComponent,
    SubscriptionPlanDetailsComponent,
    MapModifyComponent,
    MapPacksComponent,
    MapImageChangeComponent,
    AzgaarMapGeneratorInfoComponent,
    AiFailureComponent,
    TokenSuccessComponent,
    AiTokenRestockComponent,
    TokenCreditModalComponent,
    WorldCreditsModalPurchaseComponent,
    PlaceContentModalComponent,
    LoaderComponent,
    IntroSplashComponent,
    ContentDeleteModalComponent,
    SavingLoaderModalComponent,
    CartComponent,
    CheckoutComponent,
    CheckoutSuccessComponent,
    VendorOnboardingComponent,
    VendorDashboardComponent,
    AllShopsComponent,
    FavoritesComponent,
    ListingFormComponent,
    ListingDetailComponent,
    OrdersComponent,
    BulkUploadComponent,
    AdminOverviewComponent,
    AdminUsersComponent,
    AdminUserDetailComponent,
    AdminReportsComponent
  ],

  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    CommonModule,
    NgSelectModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AutocompleteLibModule,
    NgbModule,
    NgxPermissionsModule.forRoot(),
    RouterModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    WorldBuilderModule,
    // ngx-stripe v21 ships these as standalone — imported directly here
    // since CheckoutComponent (needing them) is declared in this module.
    StripeElementsDirective,
    StripePaymentElementComponent,
    AuthPagesModule,
  ],
  providers: [
    NgbActiveModal,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PreviewInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshPlanDetailsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GetNotificationCountInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MarketplaceAuthInterceptor,
      multi: true
    },
    // Was never actually provided anywhere before this — the existing
    // subscription/strip.component.ts injects StripeService but Stripe.js
    // had no key configured. NOTE: environment.stripePublishableKey is
    // currently a pk_live_ key — swap for a pk_test_ key before exercising
    // any real checkout flow locally.
    provideNgxStripe(environment.stripePublishableKey),
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule { }
